// extracted by mini-css-extract-plugin
export var cardGrid = "eventsAndNews-module--card-grid--2JeyV";
export var awardSection = "eventsAndNews-module--award-section--3snOT";
export var wide = "eventsAndNews-module--wide--TOSiz";
export var awards = "eventsAndNews-module--awards--10PN4";
export var upcoming = "eventsAndNews-module--upcoming--1Y_al";
export var grey = "eventsAndNews-module--grey--36qdX";
export var alabaster = "eventsAndNews-module--alabaster--12sai";
export var blue = "eventsAndNews-module--blue--2XCcf";
export var assets = "eventsAndNews-module--assets--1byWa";
export var logos = "eventsAndNews-module--logos--1zXgs";
export var assetBtn = "eventsAndNews-module--asset-btn--24qP0";
export var heroGrid = "eventsAndNews-module--hero-grid--YL1uR";
export var heroContainer = "eventsAndNews-module--hero-container--1pWbI";
export var ctaLink = "eventsAndNews-module--cta-link--2TRVZ";
export var heroContent = "eventsAndNews-module--hero-content--2_lrP";
export var heroImage = "eventsAndNews-module--hero-image--svSab";
export var brandWrapper = "eventsAndNews-module--brand-wrapper--55Fu5";
export var content = "eventsAndNews-module--content--ugPVv";